'use strict';

var $ = require('jquery');

var classNames = {
	panel: 'panel'
};

function loadClickPanels($context) {
	$.findByBem(classNames.panel, null, 'clickable', $context).on('click.panel', function (e) {
		e.stopImmediatePropagation();
		if (!$(e.target).is('a')) {
			var $firstLink = $(e.target).find('a:first-child');
			if ($firstLink.length > 0) {
				$firstLink.trigger('click');
			} else {
				$(this).find('a')[0].click();
			}
		}
	});
}

module.exports = {

	init: function ($context) {
		loadClickPanels($context);
	}

};